import Vue from 'vue';
import {Component , Prop , Emit } from 'vue-property-decorator';
import { LabelSetting } from '../../../i18n/locale-helper';
@Component({
    name: "InnerModalDialogComponent",
    template: require('./template.html')
})
class InnerModalDialogComponent extends Vue {
    @Prop({ default: 'Title', required: true })
    title: string;
    @Prop({ default: '' })
    icon: string;
    @Prop()
    width: string;
    @Prop({ default: '15vh' })
    top: string;
    @Prop({ default: false })
    createAnother: boolean;
    @Prop({ default: false })
    allowCreateAnother: boolean;
    @Prop({ default: false })
    loading: boolean;
    @Prop({ default: false })
    closeOnClickModal: boolean;
    @Prop({ default: true })
    appendToBody: boolean;
    @Prop({ default: false, required: true })
    visible: boolean;
    @Prop({type: Boolean, default: true}) isNew;
    @Prop({type: Boolean, default: true}) isSave;
    @Prop({ default: true, type: Boolean}) isShowClose;
    @Prop({ default: true, type: Boolean}) showCancel;
    @Prop({ default: true, type: Boolean}) showFooter;
    @Prop({ default: '', type: String }) contentConfirm;
    @Prop({ default: false, type: Boolean }) isDataChange;
	@Prop({ default: false}) isLoading: boolean;
    get coShowClose() { return this.isShowClose; }
    get lblSetting() {
        return LabelSetting.Action;
    }
    get coWidth(): string {
        return this.width;
    }
    set coWidth(value: string) {
        this.$emit('update:width', value)
    }
    get coTop(): string {
        return this.top;
    }
    get coCloseOnClickModal() {
        return this.closeOnClickModal;
    }

    get coTitle(): string {
        return this.title;
    }

    get coIsNew (): Boolean { return this.isNew }
    get coIsSave (): Boolean { return this.isSave }
    get coIcon(): string {
        return this.icon;
    }
    get coAllowCreateAnother(): boolean {
        return this.allowCreateAnother;
    }
    get coCreateAnother(): boolean {
        return this.createAnother;
    }
    set coCreateAnother(value: boolean) {
        this.$emit('update:createAnother', value)
    }
    get coVisible(): boolean {
        return this.visible;
    }
    set coVisible(value: boolean) {
        this.$emit('update:visible', value);
    }
    get coLoading(): boolean {
        return this.loading;
    }
    set coLoading(value: boolean) {
        this.$emit('update:loading', value)
    }
    /**
     *
     */
    constructor(props: any) {
        super(props);
    }

    @Emit('save')
    handleSave() {
    }

    @Emit('cancel')
    handleCancel(val = false) {
        this.coVisible = false;
        if (!val) {
            this.$emit('no-save')
        } else {
            this.$emit('close-dialog')
        }
    }

    @Emit('close')
    handleClose() {

    }

    handleOpen() {
        this.$emit('open')
    }

    beforeDestroy(){
    }
}

export default InnerModalDialogComponent;